// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.waitlist.RentalManagerUserPropertyWaitlistWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyWaitlistWebApiHandler_disable,
  RentalManagerUserPropertyWaitlistWebApiHandler_enable,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { ListingAlias } from '@zg-rentals/ts-rental-manager-api-client';

interface DisableParams {
  customerId: string;
  listingAlias: ListingAlias;
}
interface EnableParams {
  customerId: string;
  listingAlias: ListingAlias;
}

export interface RentalManagerUserPropertyWaitlistWebApiHandler_disable_Args {
  getParams: DisableParams;
}

export type RentalManagerUserPropertyWaitlistWebApiHandler_disable_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyWaitlistWebApiHandler_disable_Args
>;

/**
 * Disable waitlist feature for a property
 */
export const useRentalManagerUserPropertyWaitlistWebApiHandler_disable = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyWaitlistWebApiHandler_disable_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyWaitlistWebApiHandler_disable_Args) =>
      RentalManagerUserPropertyWaitlistWebApiHandler_disable(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyWaitlistWebApiHandler_enable_Args {
  getParams: EnableParams;
}

export type RentalManagerUserPropertyWaitlistWebApiHandler_enable_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyWaitlistWebApiHandler_enable_Args
>;

/**
 * Enable waitlist feature for a property
 */
export const useRentalManagerUserPropertyWaitlistWebApiHandler_enable = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyWaitlistWebApiHandler_enable_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyWaitlistWebApiHandler_enable_Args) =>
      RentalManagerUserPropertyWaitlistWebApiHandler_enable(args.getParams, httpClient),
  });
};
